import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { IThreatAssessmentTeam } from '../../../../../shared/models/contact';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SpinnerComponent } from '../../../../components/spinner/spinner.component';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';

@Component({
  selector: 'reviewer-info',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent
  ],
  templateUrl: './reviewer-info.component.html',
  styleUrl: './reviewer-info.component.css'
})
export class ReviewerInfoComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() rmsRecordReviewData: any;
  @Output() onSaveSection1 = new EventEmitter<any>();

  @ViewChild('datepickerStartDate') datepickerStartDate!: ElementRef;

  yesNo = EYesNo;
  reviewerInfoForm: FormGroup = new FormGroup([]);
  
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  currentContact: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private contactsService: ContactsService,
    private userDataService: UserDataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentContact = this.userDataService.getCurrentUser();
    this.initializeForm();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rmsRecordReviewData'] && this.rmsRecordReviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    group['date_started'] = new FormControl(this.rmsRecordReviewData?.date_started || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), Validators.required);
    group['time_started'] = new FormControl(this.rmsRecordReviewData?.time_started || '11:00', Validators.required);
  
    this.reviewerInfoForm = new FormGroup(group);
  }

  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import the Datepicker to avoid server-side loading
      const { Datepicker } = await import('flowbite-datepicker');
      if (this.datepickerStartDate) {
        new Datepicker(this.datepickerStartDate.nativeElement, {
          autohide: true,
          format: 'mm/dd/yyyy'
        });
        // set default value to display for incident date
        if (this.rmsRecordReviewData?.date_started) {
          // if date_of_incident is available, set it to the datepicker
          this.datepickerStartDate.nativeElement.value = DateUtils.formatDateForDisplay(this.rmsRecordReviewData.date_started);
        } else {
          // if date_of_incident is not available, set it to the current date
          this.datepickerStartDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
        }
        this.datepickerStartDate.nativeElement.addEventListener('changeDate', (event: any) => {
          const formattedDate = DateUtils.formatDateForBackend(event.target.value);
          this.reviewerInfoForm.get('date_started')?.setValue(formattedDate);
        });
      }
    }
  }

  saveReviewerInfo(): void {
    if (this.reviewerInfoForm.valid) {
      const data = this.reviewerInfoForm.value;
      this.onSaveSection1.emit(data);
    }
  }

}
